import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage'; 
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

import { isLocal } from './config';

const firebaseConfig = {
  apiKey: "AIzaSyCHy8uzRY4M1JD6SQVwHDqj07a4tzjYLho",
  authDomain: "prmassist-portal.firebaseapp.com",
  databaseURL: "https://prmassist-portal-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "prmassist-portal",
  storageBucket: "prmassist-portal.appspot.com",
  messagingSenderId: "607857257143",
  appId: "1:607857257143:web:9e6ea157b9468935e5bb32",
  measurementId: "G-7FNG3ZFMFH"
};

try {
    firebase.initializeApp(firebaseConfig);
  } catch (err) {
    if (!/already exists/.test(err.message)) {
      console.error('Firebase initialization error', err.stack);
    }
  }

const fire = firebase;
export default fire;

const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
const analytics = getAnalytics(app);

let emulatorsConnected = false;
if (isLocal && !emulatorsConnected) {
  emulatorsConnected = true;
  console.log('Localhost detected — connecting to Firebase emulators (prmassist1)');

  connectAuthEmulator(getAuth(app), 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(getFirestore(app), 'localhost', 8080);
  connectStorageEmulator(storage, 'localhost', 9199);

  firebase.auth().useEmulator('http://localhost:9099');
  firebase.firestore().useEmulator('localhost', 8080);
}
